<template>
<div class="chapter">
<div class="inner_page">
<p class="fcenter2"><a id="page_ii"></a>With loving memories of</p>
<p class="fcenter">Anthony Charles ‘Tony’ Evans (ACE)</p>
<p class="fcenter">8 October 1942 (Higher Bebington, Wirral)</p>
<p class="fcenter">to 9 October 2018 (Christchurch, New Zealand)</p>
<p class="fcenter1"><em class="italic">I have laid aside business, and gone a-fishing</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Memory.vue?6f71af6b